module.exports = __webpack_public_path__ + "static/media/OswaldBold.db309e73.woff";